<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside mb-3" style="top: 120px;">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-12 col-xl-9">
                        <div>
                            <h2>Nouvelle Équipe</h2>
                        </div>
                        <hr />
                        <form @submit.prevent="createTeam">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Nom de l'Équipe</label>
                                        <input type="text" class="form-control" v-model="team.name" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex flex-row align-items-center mt-1 mb-3">
                                        <img :src="previewUrl || defaultImage" class="mr-3" style="width: 70px;" />
                                        <label class="btn btn-primary text-sm rounded-pill mr-3 mb-0">
                                            <b><i class="material-symbols-outlined text-sm mr-1">upload</i>
                                                Importer votre logo</b>
                                            <input type="file" class="d-none" @change="handleFileUpload"
                                                accept="image/*">
                                        </label>
                                        <div class="text-muted">
                                            <p class="text-xs m-0">Allowed JPG, JPEG or PNG.</p>
                                            <p class="text-xs m-0">Max size of 2MB.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Format</label>
                                        <select class="form-control custom-select" v-model="team.format" required="">
                                            <template v-for="n in 11">
                                                <option v-if="n>=5" :value="n+'v'+n">{{ n }}v{{ n }}</option>
                                            </template>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Délégation</label>
                                        <input type="text" class="form-control" :value="team.delegation" disabled=""/>
                                    </div>
                                </div>
                            </div>
                            <div class="submit-section">
                                <button type="submit" class="btn btn-primary submit-btn btn-rounded">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Enregistrer</label>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>
</template>
<style>
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import defaultImagePath from '@/assets/img/photo.png'

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
    },
    data() {
        return {
            defaultImage: defaultImagePath,
            previewUrl: null,
            selectedFile: null,
            team: {},
            player: {},
            user: {},
        }
    },
    mounted() {
        this.user = this.currentUser
        this.getMyPlayerProfile()
        this.getCurrentTeams()
        this.team.delegation = this.user.delegation
        const vm = this
        $(document).ready(function() {
            
        })
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0]
            if (file) {
                this.selectedFile = file
                this.previewUrl = URL.createObjectURL(file)
            }
        },
        async createTeam() {
            const formData = new FormData()
            formData.append('form_data', JSON.stringify(this.team))
            formData.append('logo', this.selectedFile)

            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.post('/private/teams', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            .then(response => {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'check_circle',
                    icon_color: 'text-success',
                    title: 'Succès',
                    detail: 'L\'équipe a été créée avec succès.',
                })
                // alert('Team added successfully');
                this.$router.push('/my/teams');
            })
            .catch(error => {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: error.response.data.detail
                })
            })
            .finally(() => {
                $('.submit-section button').removeAttr('disabled')
                $('.submit-section button span').addClass('d-none')
            })
        },
        getMyPlayerProfile() {
            api.get('/private/players/me')
                .then(response => {
                    const result = response.data
                    this.player = result
                })
        },
        getCurrentTeams() {
            api.get('/private/players/my/teams/current')
                .then(response => {
                    const result = response.data
                    this.teams = result.filter(team => team.owner_id === this.player.id);
                    if (this.teams.length >= 1) {
                        this.$store.dispatch('modal/triggerModal', {
                            icon: 'error',
                            icon_color: 'text-danger',
                            title: 'Erreur',
                            detail: "Vous avez le droit de créer qu'une seule équipe."
                        })
                        this.$router.push('/my/teams');
                    }
                })
        },
    },
};
</script>
